import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigation from './TopNavigation';

export default withNavigationTheme(TopNavigation);
